module.exports = __webpack_public_path__ + "static/media/sitebuilder-ai-es.8ded223c.png";